/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Connect_CtaInputs */

const cs_calendar_connect_cta = /** @type {(inputs: Calendar_Connect_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro synchronizaci připojte Google nebo Outlook`)
};

const en_calendar_connect_cta = /** @type {(inputs: Calendar_Connect_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Google or Outlook to sync`)
};

/**
* | output |
* | --- |
* | "Connect Google or Outlook to sync" |
*
* @param {Calendar_Connect_CtaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_connect_cta = /** @type {((inputs?: Calendar_Connect_CtaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Connect_CtaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_connect_cta(inputs)
	return cs_calendar_connect_cta(inputs)
});